<template>
	<div class="zip-container" @keydown.esc="close">
		<div
			class="flex inline left-section"
			@click="close"
			@keydown.enter="close"
			role="button"
			tabindex="0"
			aria-label="Close ZIP code Picker"
		>
			<i class="fa fa-times" aria-hidden="true"></i>
			<span class="close-span">
				CLOSE
			</span>
		</div>
		<zip-input
			class="flex-right blue"
			:error="zipInputError"
			:disabled="loading"
			:loading="shippingLoading"
			btn-class="dark-blue-rounded-square"
			btn-icon="chevron-right"
			placeholder="ZIP Code"
			@clearError="clearError"
			@submit="handleSubmit"
		/>
	</div>
</template>

<script>
import ZipInput from '../ZipInput.vue';
import { CartUpdateResolutionType } from 'JS/types/Order';

export default {
	name: 'ExpandableZipArea',
	components: { ZipInput },
	props: {
		loading: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			zipInputError: null,
			zipLoading: false,
		};
	},
	computed: {
		shippingLoading() {
			return this.zipLoading || this.$store.state.shippingLoading;
		},
	},
	methods: {
		clearError() {
			this.zipInputError = null;
		},
		close() {
			this.clearError();
			return this.$emit('close');
		},
		async handleSubmit(zip) {
			if (!zip || zip.length < 5) return this.zipInputError = 'Please enter a 5 digit ZIP code';

			this.zipLoading = true;
			const response = await this.$store.dispatch('updateShipToZip', zip);
			this.zipLoading = false;
			if (response.resolutionType === CartUpdateResolutionType.InvalidZip) {
				this.zipInputError = 'Invalid ZIP code';
				return;
			}
			this.$emit('close');
		}
	}
};
</script>

<style lang="less" scoped>
@import '../../../../less/_mixins';
.zip-container {
	background-color: #C3C3C3;
	color: #777777;
	max-width: 510px;
	width: 100%;
	padding: 5px;
	justify-content: space-between;
	display: flex;
	align-items: center;
}
.right-section, .left-section {
	display: inline-flex;
}
.right-section {
	input {
		font-size: 16px;
		color: #666666;
	}
}
.left-section {
	padding: 10px;
	font-size: 12px;
	font-weight: bold;
	cursor: pointer;
	.fa-times {
		font-size: 14px;
	}
	.close-span {
		padding: 2px 0 0 5px;
	}
}

@media screen and (max-width: @tablet) {

}

@media screen and (max-width: @mobile) {
	.zip-container {
		max-width: 100%;
	}
	.right-section {
		input {
			font-size: 14px;
		}
	}
	.left-section {
		padding: 5px;
		font-size: 10px;
		.fa-times {
			font-size: 12px;
		}
	}
}
</style>